export const wordStatusMap = {
    0: '未开始',
    1: '不认识',
    2: '模糊',
    3: '认识'
}
